<!-- 赞助 -->
<template>
  <div class="sponsor">
    <v-head v-if="isshowHead"></v-head>
    <div class="container" style="min-width:1200px;">
      <!-- banner轮播 -->
      <div class="sponsor-banner">
        <el-carousel trigger="click" :interval="5000" arrow="never" height="100%">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <div class="banner-img" :style="'background-image:url(' + item.image_url + ')'"></div>
            <div class="sponsor-banner-con" @click="clickbanner(item)">
              <div class="sponsor-banner-title">{{ item.title }}</div>
              <div class="sponsor-banner-line">—</div>
              <div class="sponsor-banner-message">{{ item.description }}</div>
              <div class="sponsor-banner-more">
                <a :href="item.url" target="blank">
                  <el-button size="small">
                    {{ item.button_name }}
                    <i class="el-icon-arrow-right"></i>
                  </el-button>
                </a>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 活动展示 -->
      <div class="sponsor-activity">
        <!-- 活动切换nav -->
        <el-tabs class="sponsor-activity-nav" v-model="activityed" type="border-card">
          <el-tab-pane
            v-for="(item,index) of activityList"
            :key="index"
            :label="item.label"
            :name="item.label"
          >
            <div class="sponsor-activity-con">
              <div class="activity-con-title">{{ item.label }}</div>
              <div class="activity-con-message">{{ item.message }}</div>
              <div class="activity-con-cut">
                <div
                  class="activity-cut-prev"
                  :class="activityed === activityList[0].label?'activity-disabled':''"
                  @click="prev()"
                >
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div
                  class="activity-cut-next"
                  :class="activityed === activityList[activityList.length-1].label?'activity-disabled':''"
                  @click="next()"
                >
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 赞助案例 -->
      <div class="sponsor-case">
        <div class="case-title">
          <span class="case-title-t">赞助案例</span>
          <span class="case-title-b">让企业更为直观的了解我们的产品</span>
        </div>
        <div class="case-main">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item,index) of caseList"
                :key="index"
                v-if="showSwoper"
              >
                <div class="case-msg-img" :style="'background-image:url(' + item.picUrl + ')'">
                  <div class="case-msg-zz"></div>
                </div>
                <!-- <img :src="item.picUrl" alt width="100%" height="100%" /> -->
                <div class="case-messagebox">
                  <div class="case-msg-title">{{ item.title }}</div>
                  <div class="case-msg-more">
                    <a href="javascript:void(0);" @click="toSponsorDetailes(item.sponsorId)">了解更多 ></a>
                  </div>
                </div>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="el-icon-arrow-left arrow-left" v-show="prevClick"></div>
          <div class="el-icon-arrow-right arrow-right" v-show="nextClick"></div>
        </div>
      </div>
      <!-- 关联企业 -->
      <v-relation style="background-color:#ffffff;"></v-relation>
    </div>
    <!-- footer -->
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import bg from '@/assets/img/bg-zz.png'
import vRelation from '@/components/relation/relation.vue'
import {
  Carousel,
  CarouselItem,
  Button,
  Tabs,
  TabPane
} from 'element-ui'
import Swiper from 'swiper'
export default {
  data () {
    return {
      img: bg, // 临时图片
      activityed: '活动冠名',
      // banner数据
      isshowHead: false,
      bannerList: [],
      activityList: [{
        label: '活动冠名',
        message: '千家校园每天有万场校园活动开展，不同类型的活动可以进行活动冠名，总有一款活动适合企业定位'
      }, {
        label: '物资赞助',
        message: '每天万场校园活动可以为企业提供物资赞助对象，将企业自身物资生产优势与校园活动结合，在学生群体中推广企业品牌'
      }, {
        label: '线下推广',
        message: '12万个校园社团、400万大学生可以给企业提供讲座、传单、易拉宝、展台、横幅、校园餐桌、校园广告栏等各种形式线下校园推广'
      }, {
        label: '线上推广',
        message: '千家校园内部媒体平台、十万级校园新媒体平台为企业提供线上宣传平台，有效扩大宣传触及面'
      }],
      caseList: [],
      prevClick: true,
      nextClick: true
    }
  },
  computed: {
    showSwoper () {
      return this.caseList.length
    }
  },
  components: {
    'el-carousel': Carousel,
    'el-carousel-item': CarouselItem,
    'v-head': vHead,
    'v-footer': vFooter,
    'el-button': Button,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'v-relation': vRelation
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  mounted () {
    let _ = this
    // eslint-disable-next-line
    this.init(() => {
      var mySwiper = new Swiper('.swiper-container', {
        observer: true,
        observeParents: true,
        loop: false,
        initialSlide: 0,
        slidesPerView: 4,
        speed: 200,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        // 前进后退按钮
        navigation: {
          nextEl: '.arrow-right',
          prevEl: '.arrow-left'
        }
      })
      // 初始化判断swiper轮播图箭头显示隐藏
      if (mySwiper.activeIndex === (_.caseList.length - mySwiper.passedParams.slidesPerView)) {
        _.nextClick = false
        _.prevClick = true
      } else if (mySwiper.activeIndex === 0) {
        _.prevClick = false
        _.nextClick = true
      } else {
        _.prevClick = true
        _.nextClick = true
      }
      // 监听swiper轮播图轮播时候箭头显示隐藏
      mySwiper.on('slideChangeTransitionEnd', function () {
        if (mySwiper.activeIndex === (_.caseList.length - mySwiper.passedParams.slidesPerView)) {
          _.nextClick = false
          _.prevClick = true
        } else if (mySwiper.activeIndex === 0) {
          _.prevClick = false
          _.nextClick = true
        } else {
          _.prevClick = true
          _.nextClick = true
        }
      })
      // 判断如果一页展示数量不足，则隐藏两边切换箭头
      if (_.caseList.length <= 4) {
        _.nextClick = false
        _.prevClick = false
      }
    })
    // banner请求
    this.$http({
      method: 'POST',
      url: '/banner/bannerList',
      params: {
        subType: 11 // 临时
      }
    }).then(res => {
      if (res.code === 100) {
        this.isshowHead = true
        this.bannerList = res.result
      }
    }).catch(error => {
      console.log(error)
      return false
    })
  },
  methods: {
    init (callback) {
      this.$http({
        method: 'post',
        url: '/sponsor/case/list'
      }).then(res => {
        if (res.code === 100) {
          this.caseList = res.result.list
          if (callback) {
            this.$nextTick(function () {
              callback()
            })
          }
        }
      }).catch(error => {
        console.log(error)
        return false
      })
    },
    prev () {
      for (let i = 0; i < this.activityList.length; i++) {
        if (this.activityList[i].label === this.activityed) {
          if (i === 0) {
            return
          } else {
            this.activityed = this.activityList[i - 1].label
            return
          }
        }
      }
    },
    next (e) {
      for (let i = 0; i < this.activityList.length; i++) {
        if (this.activityList[i].label === this.activityed) {
          if (i === (this.activityList.length - 1)) {
            return
          } else {
            this.activityed = this.activityList[i + 1].label
            return
          }
        }
      }
    },
    toSponsorDetailes (id) {
      this.$router.push({
        path: '/sponsor-det',
        query: {
          id: id
        }
      })
    },
    // banner点击事件
    clickbanner (item) {
      this.$http({
        method: 'post',
        url: '/banner/increase',
        params: {
          id: item.id
        }
      }).then(res => {
        if (res.code === 100) {
          return false
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        console.log(error)
        return false
      })
    }
  }
}
</script>
<style src='./sponsor_active.scss' lang="scss"></style>
<style src='./sponsor.scss' lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/sponsor/sponsor.vue